import { render } from "./CommunityGuidelines.vue?vue&type=template&id=21771f46&scoped=true"
import script from "./CommunityGuidelines.vue?vue&type=script&lang=js"
export * from "./CommunityGuidelines.vue?vue&type=script&lang=js"

import "./CommunityGuidelines.vue?vue&type=style&index=0&id=21771f46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21771f46"]])

export default __exports__